import React, { useState } from "react"
import PropTypes from "prop-types"
import { uniqueId } from "lodash"

import { TelephoneDropdown } from "./TelephoneDropdown"

import {
  StyledCheckValidation,
  StyledCrossValidation,
  StyledTelephoneWrapper,
  StyledInput,
} from "./partials"

import { StyledTelephoneContainer, StyledFieldWrapper } from "./partials/StyledField"
import IconV2 from "../icon-v2"

const Input = ({
  id,
  placeholder,
  name,
  label,
  type,
  required,
  hidden,
  disable,
  countryCode,
  value,
  onChange,
  isValid,
  isoCountry,
  isDark,
  loading,
}) => {
  const [phoneValid, setPhoneValid] = useState(isValid)
  const htmlId = uniqueId(id)

  const pattern = "^[0-9]{6,20}"

  function handleChange(e) {
    if (e.name === name) {
      setPhoneValid(e.validity.valid)
      let newVal = e.value

      if (newVal.length > 6) {
        if (e.value.substring(0, 3) === countryCode) {
          newVal = e.value.substring(3)
        } else if (e.value.substring(0, 2) === countryCode) {
          newVal = e.value.substring(2)
        } else if (e.value.substring(0, 4) === countryCode) {
          newVal = e.value.substring(4)
        }
      }

      onChange(id, {
        value: newVal,
        valid: e.validity.valid,
        countryCode: countryCode,
        isoCountry: isoCountry,
      })
    } else {
      onChange(id, {
        value: value,
        valid: phoneValid,
        countryCode: e.countryCode,
        isoCountry: e.isoCountry,
      })
    }
  }

  return (


<>

        <StyledFieldWrapper
        data-name="field-telephone"
            isDark={isDark}
            hidden={hidden}
            valid={isValid}
            loading={loading}
            phone={true}
            empty={!value || value.length < 1}
        >
            <TelephoneDropdown
                isoCountry={isoCountry}
                countryCode={countryCode}
                onChange={handleChange}
                valid={isValid}
                isDark={isDark}
            />
            <div>
                {isValid && (<IconV2 icon={"check-circle"} size={"14"} iconType={"fas"} />)}
                {isValid === false && (<IconV2 icon={"exclamation-circle"} size={"14"} iconType={"fas"} />)}
                <input
                    className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
                    id={htmlId}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    required={required}
                    disabled={loading ? "disabled" : disable}
                    value={value}
                    pattern={pattern}
                    onChange={(e) => {
                    handleChange(e.target)
                    }}
                />
                {label && <label htmlFor={htmlId}>{label}</label>}
            </div>
            {isValid === false && (
                value.length > 0 ? (
                    <span>Invalid data entry</span>
                ) : (
                    <span>This is required</span>
            ))}

            
        </StyledFieldWrapper>

    </>


    // <StyledTelephoneWrapper hidden={hidden} isDark={isDark} valid={isValid} loading={loading}>
    //   {label && (
    //     <label htmlFor={htmlId}>
    //       {label}
    //       {isValid === false &&
    //         (value.length > 0 ? (
    //           <span>Invalid data entry</span>
    //         ) : (
    //           <span>This is required</span>
    //         ))}
    //     </label>
    //   )}
    //   <div>
        // <TelephoneDropdown
        //   isoCountry={isoCountry}
        //   countryCode={countryCode}
        //   onChange={handleChange}
        //   valid={isValid}
        //   isDark={isDark}
        // />
    //     <StyledInput isDark={isDark} valid={isValid}>
        //   <input
        //     id={htmlId}
        //     name={name}
        //     type={type}
        //     placeholder={placeholder}
        //     required={required}
        //     disabled={loading ? "disabled" : disable}
        //     value={value}
        //     pattern={pattern}
        //     onChange={(e) => {
        //       handleChange(e.target)
        //     }}
        //   />
    //       {isValid && <StyledCheckValidation />}
    //       {isValid === false && <StyledCrossValidation />}
    //     </StyledInput>
    //   </div>
    // </StyledTelephoneWrapper>
  )
}

Input.defaultProps = {
  id: "",
  className: "",
  name: "",
  placeholder: "",
  label: "",
  type: "text",
  hidden: false,
  required: false,
  disable: false,
  value: "",
  onChange: () => {},
  isValid: undefined,
  isoCountry: undefined,
  loading: false,
}

Input.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  hide_label: PropTypes.bool,
  type: PropTypes.string,
  required: PropTypes.bool,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  countryCode: PropTypes.string,
  defaultCountryCode: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  isoCountry: PropTypes.string,
  loading: PropTypes.bool,
}

export default Input
